import { useState, useContext } from "react"
import { useNavigate } from 'react-router-dom'
import { enviarFormulario } from "./funcionesLogin"
import { OverlayLogin } from "./OverlayLogin"
import {AuthContext} from "../context/AuthContext"
import { OverlayCargando } from "./OverlayLoading"

function LoginFormulario() {
    const {login} = useContext(AuthContext)

    const navigate = useNavigate()

    // --ESTADOS -- //
    //Estado de los datos del form
    const [datos, setDatos] = useState({
        email: "",
        password: ""
    })

    //Estado que almacenará los errores de validación de los campos
    const [errores, setErrores] = useState({
        email: "",
        password: ""
    })

    //Estado que establece si el form fue enviado correctamente
    const [envioExitoso, setExitoso] = useState(false)

    //Estado de carga entre que se envía el formulario y se confirma la operación exitosa
    const [loading, setLoading] = useState(false)


    // -- FUNCIÓN ACTUALIZACIÓN DE DATOS -- //
    //Se define la función encargada de actualizar en tiempo real los campos con lo que el usuario escribe y los mensajes de error
    const actualizarDatos = (d) => {
        const {name, value} = d.target

        const datosNuevos = { ...datos, [name]: value }
        setDatos(datosNuevos)
    }

    // -- DEVOLUCIÓN DE FORMULARIO -- //
    return (
        <form id="registro-form" onSubmit={(evento) => enviarFormulario({evento, datos, setDatos, setErrores, setExitoso, setLoading, navigate, login})} noValidate>
            <div>
                <label htmlFor="email" className="login-label">Dirección de correo electrónico</label><br></br>
                <input 
                    id="email"
                    type="text"                 
                    name="email" 
                    className="login-input" 
                    value={datos.email}
                    onChange={actualizarDatos}
                    required
                />
                {errores.email && <p className="error-validacion">{errores.email}</p>}
            </div>

            <div>
                <label htmlFor="password" className="login-label">Contraseña</label><br></br>
                <input 
                    id="password"
                    type="password"                 
                    name="password" 
                    className="login-input" 
                    value={datos.password}
                    onChange={actualizarDatos}
                    required
                />
                {errores.password && <p className="error-validacion">{errores.password}</p>}
            </div>

            <div>
                <button id="login-button" type="submit">Iniciar sesión</button>
            </div>
            {loading && <OverlayCargando />}
            {envioExitoso && <OverlayLogin />}
        </form>
    )
}

export default LoginFormulario